class heroSlideshow extends HTMLElement {
  constructor() {
    super();
    $("#ako-hero-slideshow").owlCarousel({
      center: true,
      items: 1,
      loop: true,
      margin: 0,
      autoplay: true,
      responsiveClass: true,
      dots: true,
      dotsData: false,
      autoplayHoverPause: true,
      nav: false,
      navText: [
        "<div class='icon-arrow-left'><svg viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow'></path></svg></div>",
        "<div class='icon-arrow-right'><svg viewBox='0 0 100 100'><path d='M 90,50 L 40,100 L 30,90 L 70,50  L 30,10 L 40,0 Z' class='arrow'></path></svg></div>",
      ],
      responsive: {
        768: {
          nav: true,
        },
      },
    });
  }
}
window.customElements.define("ako-hero-slideshow", heroSlideshow);
class akoBackToTop extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", function () {
      var backToTopButton = document.querySelector(".ako-backtop");

      backToTopButton.addEventListener("click", function (event) {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });

      window.addEventListener("scroll", function () {
        var y = window.scrollY;
        if (y > 800) {
          backToTopButton.classList.add("ako-opacity");
        } else {
          backToTopButton.classList.remove("ako-opacity");
        }
      });
    });
  }
}
window.customElements.define("ako-back-to-top", akoBackToTop);
// ako ads column
class akoAdsColumn extends HTMLElement {
  constructor() {
    super();
    jQuery(document).ready(function ($) {
      $("#ako-three").owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        responsive: {
          0: {
            items: 1,
          },
          1000: {
            items: 3,
            loop: false,
            margin: 22,
          },
        },
      });
    });
  }
}
window.customElements.define("ako-ads-column", akoAdsColumn);

// ako main slide
class akoMainSlide extends HTMLElement {
  constructor() {
    super();

    const imgs = document.querySelectorAll(".ako-slideitem");
    const leftArrow = document.querySelector(".ako-arrow-left");
    const rightArrow = document.querySelector(".ako-arrow-right");

    let currentIndex = 0;

    const defClass = (startPos, index) => {
      for (let i = startPos; i < imgs.length; i++) {
        imgs[i].style.display = "none";
      }
      imgs[index].style.display = "block";
    };

    defClass(1, 0);

    leftArrow.addEventListener("click", function () {
      currentIndex <= 0 ? (currentIndex = imgs.length - 1) : currentIndex--;
      defClass(0, currentIndex);
    });

    rightArrow.addEventListener("click", function () {
      currentIndex >= imgs.length - 1 ? (currentIndex = 0) : currentIndex++;
      defClass(0, currentIndex);
    });

    const startAutoSlide = () => {
      setInterval(() => {
        currentIndex >= imgs.length - 1 ? (currentIndex = 0) : currentIndex++;
        defClass(0, currentIndex);
      }, slideTime);
    };

    startAutoSlide();
  }
}
window.customElements.define("ako-main-silde", akoMainSlide);

// ako image text
class akoImageText extends HTMLElement {
  constructor() {
    super();

    jQuery(document).ready(function ($) {
      $("#ako-slideshow").owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        autoplay: true,
        autoplayTimeout: 6000,
        responsiveClass: true,
        nav: false,
        dots: true,

        URLhashListener: true,
        autoplayHoverPause: true,
        startPosition: "URLHash",
        // navText:["<div class='icon-arrow-left'></div>","<div class='icon-arrow-right'></div>"],
        responsive: {
          1000: {
            items: 1,
          },
        },
      });
    });
  }
}
window.customElements.define("ako-image-text", akoImageText);

// description show more
class akoDescriptionMore extends HTMLElement {
  constructor() {
    super();
    const toggleDescriptionButton = document.querySelector(".description-more");
    const descriptionContents = document.querySelector(".ako_product_content");
    toggleDescriptionButton.addEventListener("click", function () {
      if (descriptionContents.classList.contains("ako-hidden")) {
        descriptionContents.classList.remove("ako-hidden");
        toggleDescriptionButton.textContent = "收起更多介紹";
      } else {
        window.scrollTo({
          top: descriptionContents.offsetTop - 100,
          behavior: "smooth",
        });
        descriptionContents.classList.add("ako-hidden");
        toggleDescriptionButton.textContent = "看更多介紹";
      }
    });
  }
}
window.customElements.define("ako-description-more", akoDescriptionMore);
